import { possibleAttributes } from './importModel'

export const getConvertedCatalogItems = (inputItems) => {
  return inputItems.map((item) => ({
    ...item,
    class: item.classId,
    tags: item.tags !== '' ? item.tags : null,
    categories: item.categories !== '' ? item.categories : null,
  }))
}

const itemToKey = (type, item) => {
  if (type === 'name') {
    return typeof item['name'] === 'string' ? item['name'].trim() : item['name']
  } else if (type === 'sku') {
    return typeof item['sku'] === 'string' ? item['sku'].trim() : item['sku']
  } else if (type === 'both') {
    return item['name'] + (item['sku'] ? item['sku'] : '')
  } else {
    return null
  }
}

const itemMap = (type, items) => {
  const itemsMap = {}
  items.forEach((item) => {
    itemsMap[itemToKey(type, item)] = item
  })
  return itemsMap
}

const mergeItem = (fields, oldItem, newItem) => {
  const matchedItem = {}
  fields.forEach((field) => {
    const { name: fieldName, value } = mergeItemField(field, oldItem, newItem)
    matchedItem[fieldName] = value
  })

  matchedItem['id'] = oldItem.id

  return matchedItem
}

const mergeItemField = (field, oldItem, newItem) => {
  const name = field.name ? field.name : field
  const oldValue = oldItem[field]
  const newValue = newItem[field]

  if (oldValue === newValue) {
    return { name, value: oldValue }
  } else {
    return { name, value: { oldValue, newValue } }
  }
}

const select = (a, fields) => fields.map((field) => a[field])
const shallowEqualSelected = (a, b, fields) => {
  const aSubset = select(a, fields)
  const bSubset = select(b, fields)

  return shallowEqual(aSubset, bSubset)
}

const shallowEqual = (a, b) => {
  let ka = Object.keys(a)
  let kb = Object.keys(b)
  if (ka.length !== kb.length) {
    return false
  }
  for (let key of ka) {
    if (a[key] !== b[key]) {
      return false
    }
  }
  return true
}

const merge = (type, fields, oldList, newList) => {
  const oldItemsMap = itemMap(type, oldList)
  const newItems = []
  const matches = []
  newList.forEach((newItem) => {
    const key = itemToKey(type, newItem)
    const oldItem = oldItemsMap[key]
    if (oldItem !== undefined) {
      if (!shallowEqualSelected(oldItem, newItem, fields)) {
        matches.push(mergeItem(fields, oldItem, newItem))
      }
    } else {
      newItem.new = true
      newItems.push(newItem)
    }
  })

  return { newItems, matches }
}

const flattenItem = (fields, item) => {
  const result = { ...item }
  fields.forEach((field) => {
    if (item[field] !== null && typeof item[field] === 'object') {
      result[field] = item[field].newValue !== '' ? item[field].newValue : null
    }
  })
  return result
}

const updateSelected = (type, items, selected) => {
  const selectedItemsMap = itemMap(type, selected)

  return items.map((item) => {
    return {
      ...item,
      selected: selectedItemsMap[itemToKey(type, item)] !== undefined,
    }
  })
}

const mapAttributeValuesToLabels = (fieldsFromServer) => {
  return fieldsFromServer.map((x) => (possibleAttributes.find((y) => y.value === x) || {}).label).filter(x => !!x)
}

export {
  mapAttributeValuesToLabels,
  flattenItem,
  itemMap,
  itemToKey,
  merge,
  mergeItem,
  updateSelected,
  shallowEqual,
}
